{
  "previous": "पिछला",
  "next": "अगला",
  "complete": "पूर्ण करें",
  "verifyAndCheckIn": "सत्यापित करें और चेक-इन करें",
  "loading": {
    "retrievingLocation": "स्थान प्राप्त किया जा रहा है...",
    "retrievingWarehouse": "वेयरहाउस डेटा प्राप्त किया जा रहा है..."
  },
  "validation": {
    "fieldRequired": "यह फ़ील्ड आवश्यक है",
    "fieldRequiredWithLabel": "{label} आवश्यक है",
    "phoneInvalid": "यह एक वैध फ़ोन नंबर नहीं है",
    "phoneInvalidWithExample": "यह एक वैध फ़ोन नंबर नहीं है (उदाहरण: {example})"
  }
}
